<template>
	<div class="exportReport" id="pdfPrint">
		<!-- <el-button type="primary" @click="onPdf()" class="noprint">导出监测报告PDF</el-button> -->
<!--		<el-button type="primary" @click="onPng()" v-show="convert" class="noprint">导出监测报告图片</el-button>-->
    <el-button type="primary" @click="onPng()" v-show="showExportButton" class="noprint">导出监测报告图片</el-button>
		<!-- <img src="@/assets/images/dp.png" @click="onPng()" v-show="convert" class="exportpng" alt="导出监测报告图片" /> -->
		<div class="div0">
			<span>电池专检报告</span>
			<!-- <span>{{form.recordCode}}</span> -->
		</div>
		<div class="div1">
			<div class="title">基本信息</div>
			<div class="cont">
				<ul>
					<!-- <li><span>车牌号</span><span>{{form.plateNumber}}</span></li>
					<li><span>品牌</span><span>-</span></li>
					<li><span>车型</span><span>{{form.carType}}</span></li> -->
					<li><span>VIN码</span><span>{{form.vin}}</span></li>
					<li><span>行驶里程</span><span>- km</span></li>
					<li><span>电池厂家</span><span>-</span></li>
					<li><span>额定容量</span><span>{{form.ratedCapacity}} Ah</span></li>
					<li><span>额定电压</span><span>{{form.ratedVoltage}} V</span></li>
					<li><span>电池类型</span><span>{{form.batteryType}}</span></li>
					<li><span>总能量</span><span>{{form.nominalEnergy}} kWh</span></li>
					<li><span>最高总电压</span><span>{{form.maxAllowTotalVoltage}} V</span></li>
					<li><span>最高单体电压</span><span>{{form.singleMaxVoltage}} V</span></li>
					<li><span>开始SOC</span><span>{{form.initSoc}}%</span></li>
					<li><span>开始时间</span><span>{{form.beginTime}}</span></li>
					<li><span>结束时间</span><span>{{form.endTime}}</span></li>
					<li><span>结束SOC</span><span>{{form.currentSoc}}%</span></li>
					<li><span>充入容量</span><span>- Ah</span></li>
					<li><span>充入电能</span><span>- kWh</span></li>
				</ul>
			</div>
		</div>
		<div class="div2">
			<div class="title">检测总体得分</div>
			<img src="../assets/images/bgscore2.png" />
			<div class="cont">
				<div><span>{{coreIndicator.capacityMetrics}}<b>%</b></span><span>容量特性</span> </div>
				<div><span>{{coreIndicator.score}}</span><span>总体健康度</span> </div>
				<div><span>{{coreIndicator.energyIndicator}}<b>%</b></span><span>能量特性</span> </div>
			</div>
		</div>
		<div class="div3">
			<div class="title">检测核心指标</div>
			<ul>
				<li>
					<span>{{coreIndicator.capacityMetrics}}%</span>
					<span>SOH</span>
				</li>
				<!-- <li>
					<span>{{coreIndicator.currentSoc}}%</span>
					<span>SOC</span>
				</li> -->
				<li>
					<span>{{coreIndicator.sot}}%</span>
					<span>SOT</span>
				</li>
				<li>
					<span>{{coreIndicator.consistency}}%</span>
					<span>一致性</span>
				</li>
				<li>
					<span>{{coreIndicator.cooling=='0'?'正常':'故障'}}</span>
					<span>冷却性</span>
				</li>
				<li>
					<span>{{coreIndicator.thermalRunaway=='0'?'正常':'故障'}}</span>
					<span>热失控</span>
				</li>
			</ul>
		</div>
		<div class="div4">
			<div class="title">其他检测项</div>
			<table border class="tab1">
				<tr>
					<td>类型</td>
					<td>项目</td>
					<td>参考标准</td>
					<td>检测结果</td>
					<td>评叙</td>
				</tr>
				<tr>
					<td rowspan="5">性能</td>
					<td>电量显示偏差SOC</td>
					<td>&lt; {{detection.socAlarm.reference}}</td>
					<td>{{detection.socAlarm.value}}</td>
					<td class="rad" :style="{color:onColor(detection.socAlarm.result)}">
						{{detection.socAlarm.result}}
					</td>
				</tr>

				<tr>
					<td>电量剩余容量SOH</td>
					<td>&gt; {{detection.soh.reference}}</td>
					<td>{{detection.soh.value}}</td>
					<td class="rad" :style="{color:onColor(detection.soh.result)}">
						{{detection.soh.result}}
					</td>
				</tr>
				<tr>
					<td>电池管理系统精度</td>
					<td>&gt; {{detection.bmsAccuracy.reference}}</td>
					<td>{{detection.bmsAccuracy.value}}</td>
					<td class="rad" :style="{color:onColor(detection.bmsAccuracy.result)}">
						{{detection.bmsAccuracy.result}}
					</td>
				</tr>
				<tr>
					<td>充电损耗</td>
					<td>&lt; {{detection.chargingLoss.reference}}</td>
					<td>{{detection.chargingLoss.value}}</td>
					<td class="rad" :style="{color:onColor(detection.chargingLoss.result)}">
						{{detection.chargingLoss.result}}
					</td>
				</tr>
				<tr>
					<td>电压衰减</td>
					<td>&gt; {{detection.voltDecayAlarm.reference}}</td>
					<td>{{detection.voltDecayAlarm.value}}</td>
					<td class="rad" :style="{color:onColor(detection.voltDecayAlarm.result)}">
						{{detection.voltDecayAlarm.result}}

					</td>
				</tr>

				<tr>
					<td rowspan="4">安全项</td>
					<td>电压上升速率</td>
					<td>&lt; {{detection.voltRiseAlarm.reference}}</td>
					<td>{{detection.voltRiseAlarm.value}}</td>
					<td class="rad" :style="{color:onColor(detection.voltRiseAlarm.result)}">
						{{detection.voltRiseAlarm.result}}

					</td>
				</tr>
				<tr>
					<td>温度上升速率</td>
					<td>&lt; {{detection.tempRiseAlarm.reference}}</td>
					<td>{{detection.tempRiseAlarm.value}}</td>
					<td class="rad" :style="{color:onColor(detection.tempRiseAlarm.result)}">
						{{detection.tempRiseAlarm.result}}
					</td>
				</tr>
				<tr>
					<td>温度偏差</td>
					<td>&lt; {{detection.tempDiffAlarm.reference}}</td>
					<td>{{detection.tempDiffAlarm.value}}</td>
					<td class="rad" :style="{color:onColor(detection.tempDiffAlarm.result)}">
						{{detection.tempDiffAlarm.result}}
					</td>
				</tr>
				<tr>
					<td>SOC荷电状态 </td>
					<td>{{detection.socStatus.reference}}</td>
					<td>{{detection.socStatus.value}}</td>
					<td class="rad" :style="{color:onColor(detection.socStatus.result)}">
						{{detection.socStatus.result}}
					</td>
				</tr>
				<tr>
					<td rowspan="2">附加项</td>
					<td>绝缘状态</td>
					<td>{{detection.batteryInsulation.reference}}</td>
					<td>{{detection.batteryInsulation.value}}</td>
					<td class="rad" :style="{color:onColor(detection.batteryInsulation.result)}">
						{{detection.batteryInsulation.result}}
					</td>
				</tr>
				<tr>
					<td>直流内阻</td>
					<td>&lt; {{detection.dcInternalResistance.reference}} mΩ</td>
					<td>{{detection.dcInternalResistance.value}} mΩ</td>
					<td class="rad" :style="{color:onColor(detection.dcInternalResistance.result)}">
						{{detection.dcInternalResistance.result}}
					</td>
				</tr>
				<tr>
					<td colspan="5" style="text-align: left;">评叙结果分为 ：优、良、中、差。</td>
				</tr>
				<!-- <tr>
					<td colspan="5" style="text-align: left;">性能结果分5级 ：优、良、中、差、劣。<br />安全结果分4级 ：正常、定期观察、预警、异常。</td>
				</tr> -->
			</table>
			<!-- <table border class="tab2">
				<tr>
					<td>过程最高单体电压V及组号</td>
					<td>4.27（2组）</td>
					<td>终态最高单体电压V及组号</td>
					<td>4.27（2组9号）</td>
					<td>终态压差mV</td>
					<td>49（平均）</td>
				</tr>
			</table> -->
			<!-- <ul class="tab3">
				<li>
					<span class="sp1">过程最高单体电压V及组号</span><span class="sp2">4.27（2组）</span>
				</li>
				<li>
					<span class="sp1">终态最高单体电压V及组号</span><span class="sp2">4.27（2组9号）</span>
				</li>
				<li>
					<span class="sp1">终态压差mV</span><span class="sp2">49（平均）</span>
				</li>
			</ul> -->
			<!-- <p>此检测报告所用技术经过中汽研检测通过</p> -->
			<div class="logdiv">
				<ul>
					<li style="width: 100%;">
						<div class="log1">嘉大G60研究院新能源汽车数字化检测研究中心</div>
					</li>
					<!-- <li><img src="../assets/images/bglog.png" alt="" srcset="" /></li>
					<li><img src="../assets/images/bglog1.png" alt="" srcset="" /></li>
					<li><img src="../assets/images/bglog2.png" alt="" srcset="" /></li> -->
				</ul>
			</div>
		</div>
		<div class="div5">
			<div class="title">最高最低温度</div>
			<div id="ech1"></div>
		</div>
		<div class="div6">
			<div class="title">单体最高电压</div>
			<div id="ech2"></div>
		</div>
		<div class="div7">
			<div class="title">总电流</div>
			<div id="ech3"></div>
		</div>
		<!-- <div class="div8">
			<div class="title">容量分布</div>
			<div id="ech4"></div>
		</div> -->


	</div>
</template>

<script>
	import html2Canvas from 'html2canvas';
	import {
		jsPDF
	} from "jspdf";
	import {
		saveAs
	} from 'file-saver'

	import 'echarts-liquidfill'

	export default {
		props: ['pileCode', 'recordCode', 'formPrint'],
		data() {
			return {
        showExportButton: true, // 控制导出按钮显示状态
				pileCodeStr: '',
				recordCodeStr: '',
				AuthorizationStr: '',
				form: {}, //基础数据
				coreIndicator: {}, //核心指标
				detection: {
					socAlarm: {},
					soh: {},
					bmsAccuracy: {},
					chargingLoss: {},
					voltDecayAlarm: {},
					voltRiseAlarm: {},
					tempRiseAlarm: {},
					tempDiffAlarm: {},
					socStatus: {},
					batteryInsulation: {},
					dcInternalResistance: {},
				}, //检测项指标
				maxTempList: [],
				tempTimeList: [],
				maxVoltageList: [],
				voltageTimeList: [],
				maxSingleVoltageNumList: [],
				convert: false,
				gunNoStr: '',
				vinStr: '',
			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			_this.pileCodeStr = query.pileCode == undefined ? '' : query.pileCode;
			_this.recordCodeStr = query.recordCode;
			_this.AuthorizationStr = query.Authorization;

      // 如果有platform参数，则隐藏按钮
      const platformStr = query.platform;
      if (platformStr == null) {
        console.log("platformStr为空");
      } else {
        console.log(platformStr);
        this.showExportButton = false;
      }

			if (JSON.stringify(query) != '{}') {}

			this.$nextTick(() => {
				if (_this.recordCodeStr == undefined) {
					_this.gunNoStr = query.gunNo;
					_this.vinStr = query.vin;
					_this.onpileCodeAndVin();
				} else {
					_this.onReportPreview();
					_this.onSingleTempList();
					_this.onSingleVoltageList();
					_this.onTotalCurrent();
					// _this.onCapacity();
				}
			})
			setTimeout(function() {
				_this.onPng(false);
				_this.convert = true;
			}, 3000);
		},
		methods: {
			onpileCodeAndVin: function() {
				let _this = this;
				this.$api.post('/order/report/by/pileCodeAndVin', {
						gunNo: _this.gunNoStr == undefined ? '' : _this.gunNoStr,
						pileCode: _this.pileCodeStr == undefined ? '' : _this.pileCodeStr,
						vin: _this.vinStr == undefined ? '' : _this.vinStr,
					},
					function(response, context) {
						if (response.code == '200') {
							if (response.data != undefined) {
								_this.recordCodeStr = response.data;
								_this.onReportPreview();
								_this.onSingleTempList();
								_this.onSingleVoltageList();
								_this.onTotalCurrent();
								// _this.onCapacity();
							} else {
								// _this.$message({
								// 	message: "未查询到相关订单",
								// 	type: 'error',
								// 	duration: 0,
								// });

								let strhtml = '<strong>请确认相关参数是否正确！</strong><ul>' +
									'<li>pileCode(充电桩编号)：<b style="color:red">' + _this.pileCodeStr + '</b></li>' +
									'<li>vin(vin码)：<b style="color:red">' + _this.vinStr + '</b></li></ul>';
								_this.$alert(strhtml, '未查询到相关订单', {
									type: 'error',
									showConfirmButton: false,
									showClose: false,
									dangerouslyUseHTMLString: true,
									callback: action => {}
								});
							}
							
						}
					})
			},

			onSingleTempList: function() {
				let _this = this;
				this.$api.post('/order/report/single/temp', {
						pileCode: _this.pileCodeStr == undefined ? '' : _this.pileCodeStr, //充检桩编号
						recordCode: _this.recordCodeStr == undefined ? '' : _this.recordCodeStr, //订单编号
					},
					function(response, context) {
						if (response.code == '200') {
							_this.singleTempInfoList = response.data;
							_this.onSingle(response.data, "temp");
						}
					})
			},
			onSingleVoltageList: function() {
				let _this = this;
				this.$api.post('/order/report/single/voltage', {
						pileCode: _this.pileCodeStr == undefined ? '' : _this.pileCodeStr, //充检桩编号
						recordCode: _this.recordCodeStr == undefined ? '' : _this.recordCodeStr, //订单编号
					},
					function(response, context) {
						if (response.code == '200') {
							_this.singleVoltageInfoList = response.data;
							_this.onSingle(response.data, "voltage");
						}
					})
			},
			onSingle: function(list, str) {
				let _this = this;
				let singleMaxTemp = [],
					singleMinTemp = [],
					maxTempPointNum = [],
					minTempPointNum = [],
					tempRange = [],
					singleMaxVoltage = [],
					singleMinVoltage = [],
					maxSingleVoltageGroupNum = [],
					maxSingleVoltageNum = [],
					voltageRange = [],
					dateTime = [];
				if (list == undefined) return;
				for (let item of list) {
					if (item[0].length >= 18) {
						let str1 = item[0].substring(11, 19);
						let str2 = item[0].substring(5, 10);
						dateTime.push(str1 + "\n" + str2);
					} else {
						dateTime.push(item[0]);
					}

					if (str == 'temp') {
						singleMaxTemp.push(item[1]);
						singleMinTemp.push(item[2]);
						maxTempPointNum.push(item[3]);
						minTempPointNum.push(item[4]);
					} else {
						singleMaxVoltage.push(item[1]);
						singleMinVoltage.push(item[2]);
						maxSingleVoltageGroupNum.push(item[3]);
						maxSingleVoltageNum.push(item[4]);
					}
				}
				setTimeout(function() {
					if (str == 'temp') {
						_this.maxTempList = singleMaxTemp;
						_this.minTempList = singleMinTemp;
						_this.tempRangeList = tempRange;
						_this.tempTimeList = dateTime;
						_this.maxTempPointNumList = maxTempPointNum;
						_this.minTempPointNumList = minTempPointNum;

						_this.onMaxMinTemp();
					} else {
						_this.maxVoltageList = singleMaxVoltage;
						_this.minVoltageList = singleMinVoltage;
						_this.voltageRangeList = voltageRange;
						_this.voltageTimeList = dateTime;
						_this.maxSingleVoltageGroupNumList = maxSingleVoltageGroupNum;
						_this.maxSingleVoltageNumList = maxSingleVoltageNum;

						_this.onVoltage();
					}
				}, 2000)
			},
			onTotalCurrent: function() {
				let _this = this;
				this.$api.post('/order/report/total/current', {
						pileCode: _this.pileCodeStr == undefined ? '' : _this.pileCodeStr, //充检桩编号
						recordCode: _this.recordCodeStr == undefined ? '' : _this.recordCodeStr, //订单编号
					},
					function(response, context) {
						if (response.code == '200') {
							let data = response.data;
							if (data.length > 1) {
								_this.onCurrent(data[0], data[1])
							}
						}
					})
			},
			onsaveOrUpdate: function(base64Str) {
				let _this = this;
				this.$api.post('/base64/report/saveOrUpdate', {
						base64Str: base64Str,
						recordCode: _this.recordCode == undefined ? _this.recordCodeStr : _this.recordCode, //订单编号
					},
					function(response, context) {
						
					})
			},

			// 车检报告预览数据
			onReportPreview: function() {
				let _this = this;
				this.$api.post('/order/report/preview', {
						pileCode: _this.pileCode == undefined ? _this.pileCodeStr : _this.pileCode, //充电桩编号
						recordCode: _this.recordCode == undefined ? _this.recordCodeStr : _this.recordCode, //订单编号
					},
					function(response, context) {
						if (response.code == "200") {
							let data = response.data;
							if (data != undefined) {
								_this.form = data.base;
								_this.coreIndicator = data.coreIndicator;
								// _this.detection = data.detection;

								for (let item in _this.detection) {
									_this.detection[item] = data.detection[item];

									if (data.detection[item] == undefined) {
										_this.detection[item] = {
											reference: '',
											result: '-',
											value: '-'
										}
									}
								}

								_this.coreIndicator.capacityMetrics = parseInt(_this.coreIndicator.capacityMetrics)
								_this.coreIndicator.energyIndicator = parseInt(_this.coreIndicator
									.energyIndicator);
							}
						}
					}
				);
			},
			onPng: function(str=true) {
				let _this = this;
				_this.convert = false;
				setTimeout(function() {
					html2Canvas(document.querySelector('#pdfPrint'), {
						allowTaint: true
					}).then(function(canvas) {
						if(str){
							canvas.toBlob(function(blob) {
								saveAs(blob, "监测报告图片.png");
							});
							_this.convert = true;
						}
						const imgData = canvas.toDataURL('image/png');
						_this.onsaveOrUpdate(imgData);
					})
				}, 500);
			},
			onPdf: function() {
				let _this = this;
				var element = document.getElementById("app");
				var width = element.scrollWidth;
				var height = element.scrollHeight;
				_this.convert = false;
				html2Canvas(document.querySelector('#pdfPrint'), {
					allowTaint: true, //允许跨域
					taintTest: false,
					logging: false,
					useCORS: true,
					dpi: 300,
					// scale: 2,//设置放大倍数
				}).then(function(canvas) {
					// 新建一个 jsPDF 实例
					const pdf = new jsPDF('p', 'pt', [1920, 1080]);
					// 将 canvas 图像转换为 dataURL 并添加到 PDF 中
					const imgData = canvas.toDataURL('image/png');
					pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize
						.getHeight());
					// pdf.addImage(imgData, 'PNG', 0, 0, width, height);
					// 保存生成的 PDF
					pdf.save('监测报告图片.pdf');

					_this.convert = true;
				})
			},
			onMaxMinTemp: function() {
				let _this = this;

				var seriesName = '最高电压';
				let ech1 = this.$echarts.init(document.getElementById('ech1'));
				var option = {
					tooltip: {
						show: true,
						// alwaysShowContent: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {
							let timestr = new Date(1000 * params[0].axisValue);
							let texts = [timestr.getFullYear(), (timestr.getMonth() + 1), timestr
								.getDate()
							];
							var time = [timestr.getHours(), timestr.getMinutes(), timestr.getSeconds()];
							let str = texts.join('-') + " " + time.join(':') + "<br />";

							for (let data of params) {
								str += data.marker + data.seriesName + " : " + data.value + "<br />";
							}
							return str;
						}
					},
					grid: {
						left: '5%',
						right: '5%',
						bottom: '3%',
						top: '8%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: false
						},
						data: _this.tempTimeList, // ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
						axisLabel: {
							show: true,
							// color: "#fff",
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');
							}
						},
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, '50%'],
						axisLabel: {
							formatter: '{value} °C'
						},
						scale: true,
					},
					series: [{
							name: '最高温',
							type: 'line',
							showSymbol: false,
							smooth: true,
							color: '#00aaff',
							data: _this.maxTempList, // [10, 11, 13, 11, 12, 12, 9],
							markPoint: {
								data: [{
									type: 'max',
									name: 'Max'
								}, ]
							},
						},
						{
							name: '最低温',
							type: 'line',
							showSymbol: false,
							smooth: true,
							color: '#3DD4FF',
							data: _this.minTempList, // [1, -2, 2, 5, 3, 2, 0],
							markPoint: {
								data: [{
									type: 'min',
									name: 'Min'
								}]
							},
						}
					]
				};
				ech1.setOption(option);
				// setTimeout(function() {
				// 	ech1.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: _this.maxTempList.length - 1,
				// 	});
				// }, 1000);
				window.addEventListener("resize", function() {
					ech1.resize();
				});
			},
			onVoltage: function() {
				let _this = this;
				let ech2 = this.$echarts.init(document.getElementById('ech2'));
				let option = {
					grid: {
						left: '5%',
						right: '5%',
						bottom: '3%',
						top: '8%',
						containLabel: true
					},
					tooltip: {
						show: true,
						// alwaysShowContent: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {
							let data = params[0];

							let timestr = new Date(1000 * data.axisValue);

							let texts = [timestr.getFullYear(), (timestr.getMonth() + 1), timestr.getDate()];

							var time = [timestr.getHours(), timestr.getMinutes(), timestr.getSeconds()];

							let str = texts.join('-') + " " + time.join(':') + "<br />" +
								data.marker + '最高电压' + " : " + data.value + "<br />" +
								data.marker + data.seriesName + '编号 : ' + _this.maxSingleVoltageNumList[data
									.dataIndex] + "<br />" +
								data.marker + data.seriesName + '组号 : ' + _this.maxSingleVoltageNumList[data
									.dataIndex];
							return str
						}
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: false
						},
						data: _this.voltageTimeList, //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
						axisLabel: {
							show: true,
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');

							}
						},
					},
					yAxis: {
						type: 'value',
						scale: true,
						boundaryGap: [0, '50%'],
					},
					series: [{
						name: '',
						data: _this.maxVoltageList, // [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line',
						smooth: true,
						showSymbol: false,
						color: '#3DD4FF',
						markPoint: {
							data: [{
									type: 'max',
									name: 'Max'
								},
								{
									type: 'min',
									name: 'Min'
								}
							]
						},
						lineStyle: {
							type: 'dashed',
							width: 2
						}
					}]
				};
				ech2.setOption(option);

				// setTimeout(function() {
				// 	ech2.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: _this.maxVoltageList.length - 1,
				// 	});
				// }, 1000);
				window.addEventListener("resize", function() {
					ech2.resize();
				});
			},
			onCurrent: function(list1 = [], list2 = []) {
				let _this = this;
				let ech3 = this.$echarts.init(document.getElementById('ech3'));
				let option = {
					grid: {
						left: '5%',
						right: '5%',
						bottom: '3%',
						top: '8%',
						containLabel: true
					},
					tooltip: {
						show: true,
						// alwaysShowContent: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {
							let timestr = new Date(1000 * params[0].axisValue);
							let texts = [timestr.getFullYear(), (timestr.getMonth() + 1), timestr
								.getDate()
							];
							var time = [timestr.getHours(), timestr.getMinutes(), timestr.getSeconds()];
							let str = texts.join('-') + " " + time.join(':') + "<br />";

							for (let data of params) {
								str += data.marker + data.seriesName + " : " + data.value + "<br />";
							}
							return str;
						}
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: false
						},
						data: list1, // ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
						axisLabel: {
							show: true,
							// color: "#fff",
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');
							}
						},
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, '50%'],
					},
					series: [{
						name: '总电流',
						data: list2, // [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line',
						color: '#3DD4FF',
						markPoint: {
							data: [{
									type: 'max',
									name: 'Max'
								},
								{
									type: 'min',
									name: 'Min'
								}
							]
						},
						areaStyle: {
							color: {
								colorStops: [{
									offset: 0,
									color: 'rgba(61,212,255,1)'
								}, {
									offset: 0.8,
									color: 'rgba(61,212,255,0)'
								}],
							},
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						},
					}]
				};
				ech3.setOption(option);
				// setTimeout(function() {
				// 	ech3.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: list2.length - 1,
				// 	});
				// }, 1000);
				window.addEventListener("resize", function() {
					ech3.resize();
				});
			},
			onCapacity: function() {
				let _this = this;
				let ech4 = this.$echarts.init(document.getElementById('ech4'));
				let option = {
					grid: {
						left: '5%',
						right: '5%',
						bottom: '3%',
						top: '8%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
						},
						data: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00']
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, '50%'],
						axisTick: {
							show: false
						},
					},
					series: [{
						data: [120, 200, 150, 80, 70, 110, 130],
						type: 'bar',
						color: '#3DD4FF',
						barMaxWidth: 20,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						},
						itemStyle: {
							borderRadius: [20, 20, 0, 0],
						},
						markPoint: {
							data: [{
									type: 'max',
									name: 'Max'
								},
								{
									type: 'min',
									name: 'Min'
								}
							]
						},
					}]
				};
				ech4.setOption(option);

				// setTimeout(function() {
				// 	ech4.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: 1,
				// 	});
				// }, 1000);
				window.addEventListener("resize", function() {
					ech4.resize();
				});
			},
			onColor: function(value) {
				let str = '';
				switch (value) {
					case '良':
					case '中':
						str = 'orange';
						break;
					case '差':
						str = 'red';
						break;
					default:
						break;
				}
				return str;
			},


		},
		watch: {
			formPrint: function(newValue, oldValue) {
				console.log("formPrint:", newValue);
			},
		},
	}
</script>

<style lang="scss" scoped>
	html,
	body,
	#app {
		height: max-content !important;
		background: #ffffff;
		-webkit-print-color-adjust: exact;
		-ms-overflow: scroll;
		-ms-overflow-style: none;
	}

	@media print {
		#app {
			background-color: #14266E !important;
		}

		.noprint {
			display: none;
			background-color: white !important;
		}
	}

	.exportReport {
		margin: auto;
		width: 100%;
		max-width: 1100px;
		font-size: 14px;
		color: #808080;
		padding-bottom: 50px;

		.noprint {
			position: fixed;
			right: 10%;
			top: 50%;
			z-index: 99;
		}

		.exportpng {
			display: none;
		}

		div>.title {
			background-image: url('../assets/images/bgtitle.png');
			background-repeat: no-repeat;
			background-size: 100% 50px;
			color: #3DD4FF;
			font-size: 18px;
			text-indent: 40px;
			letter-spacing: 5px;
			height: 50px;
			line-height: 45px;
			font-weight: bold;
		}

		.div0 {
			background-image: url('../assets/images/bgtop.png');
			background-repeat: no-repeat;
			background-size: 100% 50px;
			height: 50px;
			font-size: 16px;
			line-height: 50px;
			padding-left: 10%;
			padding-right: 20px;
			display: flex;
			justify-content: space-between;

			span:nth-child(1) {
				letter-spacing: 5px;
				color: #383838;
				font-weight: bold;
				font-family: fangsong;
			}

			span:nth-child(2) {
				font-size: 14px;
			}
		}

		.div1 {
			height: 300px;

			ul {
				width: 90%;
				list-style: none;
				margin: 0px 5%;
				padding: 0px;

				li {
					width: calc(33% - 10px);
					float: left;
					height: 35px;
					line-height: 35px;
					margin: 5px 5px 0px;
					overflow: hidden;

					span {
						&:nth-child(1) {
							margin-right: 15px;
							width: 80px;
							display: inline-block;
						}

						&:nth-child(2) {
							color: #383838;
							font-size: 16px;
						}
					}
				}
			}
		}

		.div2 {
			background-image: url('../assets/images/bgscore.png');
			background-repeat: no-repeat;
			background-size: 80% auto;
			background-position: 46% 50%;
			width: 100%;
			height: 350px;
			position: relative;

			img {
				display: none;
			}

			.cont {
				display: flex;
				justify-content: center;
				position: absolute;
				z-index: 999;
				width: 100%;

				div {
					height: 100%;
					width: 30%;
					text-align: center;
					display: grid;
					place-items: center;

					&:nth-child(1) {
						width: 20%;
						margin-right: 15px;
					}

					&:nth-child(3) {
						width: 20%;
						margin-left: 15px;
					}

					span {
						width: 100%;

						b {
							font-size: 20px;
							vertical-align: middle;
						}

						&:nth-child(1) {
							font-size: 40px;
							// background-image: linear-gradient(#02FFBB 30%, #23B9EB 50%) !important;
							// background-clip: text;
							// color: transparent;
							color: #23B9EB;
							margin-top: 90px;
						}

						&:nth-child(2) {}
					}
				}
			}
		}

		.div3 {
			ul {
				width: 90%;
				list-style: none;
				margin: 0px 5%;
				padding: 0px;
				display: flex;
				justify-content: space-between;

				li {
					width: 22%;
					margin: 20px 10px 0px;
					background-image: url('../assets/images/bgzhib.png');
					background-repeat: no-repeat;
					background-size: 100% 90%;
					height: 150px;
					position: relative;
					font-size: 16px;

					span:nth-child(1) {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 45%;
						margin: auto;
						width: max-content;
						height: max-content;
						font-size: 30px;
						font-weight: 400;
						text-align: left;
						// background-image: linear-gradient(#02FFBB 30%, #23B9EB 50%) !important;
						// background-clip: text;
						// color: transparent;
						color: #23B9EB;
					}

					span:nth-child(2) {
						position: absolute;
						left: 0;
						right: 0;
						bottom: 0px;
						margin: auto;
						width: max-content;
						height: max-content;
					}
				}
			}
		}

		.div4 {
			.tab1 {
				width: 90%;
				margin: 10px 5%;
				border-color: #E5E5E5;
				color: #383838;

				tr {
					td {
						padding: 10px;
						padding-left: 20px;

						&:nth-child(3) {
							color: #3DD4FF;
						}
					}

				}

				tr:nth-child(1) td:nth-child(3) {
					color: #383838;
				}

				tr:nth-child(2),
				tr:nth-child(7),
				tr:nth-child(11) {
					td:nth-child(3) {
						color: #383838;
					}

					td:nth-child(4) {
						color: #3DD4FF;
					}
				}

				td.rad {
					color: #3DD4FF;

					label {
						margin-right: 20px;
					}

					input {
						margin-right: 5px;
					}

					input[type="radio"] {
						cursor: pointer;
						width: 16px;
						height: 16px;
						position: relative;
						top: 2px;
					}

					input[type="radio"]:checked::after {
						content: "";
						width: 10px;
						height: 10px;
						border-radius: 50%;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						background-color: #2196F3;
					}
				}
			}

			.tab2 {
				width: 90%;
				margin: 10px 5%;
				border-color: #E5E5E5;
				color: #383838;

				tr {
					td {
						padding: 10px;
						padding-left: 20px;
					}

				}

				td:nth-child(even) {
					color: #3DD4FF;
					font-size: 16px;
				}
			}

			.tab3 {
				display: none;
			}

			.logdiv {
				padding: 0px 50px;
				margin-top: 10px;

				ul {
					list-style: none;
					padding: 0px;
					margin: 0px;

					li {
						display: inline-block;
						width: calc(50% - 10px);
						min-height: 120px;
						margin: auto;
						text-align: center;
						padding: 10px 0px;
						box-shadow: 0px 0px 10px #f3f5f6;
						margin: 5px;
						vertical-align: top;
						max-height: max-content;
						position: relative;

						.log1 {
							// box-shadow: 0px 0px 10px #f3f5f6;
							margin: auto;
							padding: 20px;
							font-size: 30px;
							color: #0D3060;
							text-align: center;
							width: 100%;
							line-height: 40px;
						}

						img {
							width: 100%;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
							right: 0;
						}
					}
				}
			}

			p {
				margin: 30px 0px 0px;
				font-size: 16px;
				color: #383838;
				text-align: center;
			}

		}

		.div5 {}

		.div6 {}

		.div7 {}



		#ech1,
		#ech2,
		#ech3,
		#ech4 {
			height: 220px;
			width: 100%;
		}

	}

	/* 当屏幕宽度小于或等于600px时，应用下面的样式 */
	@media screen and (max-width: 600px) {
		.noprint {
			// display: none;
			right: 0px !important;
		}

		.exportpng {
			position: fixed;
			top: 50%;
			z-index: 99999;
			border-radius: 15px;
			width: 50px;
			padding: 5px;
			box-shadow: 0px 0px 18px #308ee0 inset;
			right: 10px;
			display: block !important;
		}

		.exportReport div>.title {
			background-size: auto 50px;
		}

		.div0 {
			padding-left: 10px !important;
		}

		.div1 {
			height: 420px !important;

			.cont {
				ul {
					li {
						width: calc(50% - 10px);
					}
				}
			}
		}

		.div2 {
			// background-image: url('../assets/images/bgscore2.png') !important;
			background-size: calc(100% - 20px) !important;
			height: 250px !important;
			background-image: none !important;

			img {
				position: absolute;
				left: 0;
				right: 0;
				top: 60px;
				margin: auto;
				width: calc(100% - 20px);
				z-index: 1;
				display: block !important;
			}

			.cont {

				div {
					width: 30% !important;
					height: 180px !important;
					display: flex !important;
					justify-content: center;
					flex-direction: column;

					span {
						width: 100%;

						&:nth-child(1) {
							padding-left: 25px !important;
							font-size: 30px !important;
							margin: 0px !important;
							line-height: 100px;

							b {
								font-size: 14px !important;
							}
						}

						&:nth-child(2) {
							padding-left: 15px !important;
						}

					}
				}

				div:nth-child(2) {
					span:nth-child(1) {
						font-size: 40px !important;
						padding-left: 5px !important;
						line-height: 150px;
					}
				}

				div:nth-child(3) {
					span:nth-child(1) {
						padding-left: 0px !important;
						line-height: 100px;
					}

					span:nth-child(2) {
						padding-left: 0px !important;
					}
				}
			}
		}

		.div3 {
			ul {
				display: inline-block !important;
				width: 100% !important;
				margin: 0px !important;

				li {
					float: left !important;
					width: calc(33% - 20px) !important;
					border-radius: 10px !important;
					box-shadow: 0px 0px 10px #ebeef5 !important;
				}
			}
		}

		.div4 {
			.tab1 {
				width: calc(100% - 20px) !important;
				margin: 10px !important;
				text-align: center;

				tr {
					td {
						min-width: 50px;
						padding-left: 10px !important;
					}
				}

				td.rad label {
					margin-right: 0px !important;
					display: block;
					width: 80px;
					text-align: left;
				}

				tr:nth-child(1) td:nth-child(3) {
					width: 30px !important;
					overflow: hidden;
					font-size: 14px;
				}

				tr td:nth-child(3) {
					text-align: center;
					width: 80px;
					font-size: 18px;
				}

				tr:nth-child(2),
				tr:nth-child(7),
				tr:nth-child(11) {
					td:nth-child(3) {
						color: #383838;
						font-size: 14px;
					}

					td:nth-child(4) {
						color: #3DD4FF;
						font-size: 20px;
					}
				}
			}

			.tab2 {
				display: none;
			}

			.tab3 {
				display: block !important;
				border: 1px solid #E5E5E5 !important;
				width: calc(100% - 20px);
				list-style: none;
				margin: 10px;
				padding: 0px;
				border-top: 0px !important;

				li {
					border-top: 1px solid #E5E5E5;

					.sp1 {
						border-right: 1px solid #E5E5E5;
						display: inline-block;
						min-width: 180px;
						height: 50px;
						line-height: 50px;
						padding-left: 10px;
						width: 50%;
						color: #383838;
					}

					.sp2 {
						color: #3DD4FF;
						font-size: 20px;
						padding-left: 10px;
					}
				}
			}

			.logdiv {
				display: block !important;
				padding: 0px !important;
				padding-top: 20px !important;

				ul {
					li {
						width: calc(100% - 20px) !important;
						margin: 5px 10px !important;
					}
				}
			}

			img {
				width: 100% !important;
				margin: 0px !important;
			}
		}

		#ech1,
		#ech2,
		#ech3,
		#ech4 {
			height: 220px;
			width: calc(100% - 20px) !important;
			box-shadow: 0px 0px 10px #ebeef5;
			margin: 10px;
			border: 0px solid red;
			border-radius: 10px;
			padding: 10px;
		}

	}
</style>